import { getBrowserApiBaseUrl, getClientFetchInit } from "@/lib/browserBackend";

export type PlatformTrackerPlatform = "web" | "teams";

export type PlatformTrackerResponse = {
  id: number;
  user_email: string;
  platform: PlatformTrackerPlatform;
  timestamp: string;
};

/**
 * GET /api/v1/platform-tracker?platform=web|teams — log login by platform.
 */
export async function trackPlatformLogin(
  platform: PlatformTrackerPlatform,
  accessToken?: string | null
): Promise<PlatformTrackerResponse> {
  const baseUrl = getBrowserApiBaseUrl();
  if (!baseUrl) {
    throw new Error("API base URL is not configured.");
  }

  const url = `${baseUrl.replace(/\/$/, "")}/api/v1/platform-tracker?platform=${encodeURIComponent(platform)}`;

  const res = await fetch(url, getClientFetchInit(accessToken, { method: "GET" }));

  let body: unknown;
  try {
    body = await res.json();
  } catch {
    if (!res.ok) {
      throw new Error(res.statusText || "Platform tracker request failed.");
    }
    return {} as PlatformTrackerResponse;
  }

  if (!res.ok) {
    const detail =
      typeof body === "object" &&
      body !== null &&
      "detail" in body &&
      body.detail != null
        ? String((body as { detail: unknown }).detail)
        : res.statusText || "Platform tracker request failed.";
    throw new Error(detail);
  }

  return body as PlatformTrackerResponse;
}
